export default [
    {
      path: '/admin/agency/package-return',
      name: 'package-return',
      meta: { requiresAuth: true },
      component: () => import('@/pages/agency/package-return/index.vue')
    },
    {
      path: '/admin/agency/package-return/create',
      name: 'package-return-create',
      meta: { requiresAuth: true },
      component: () => import('@/pages/agency/package-return/create.vue')
    }
  ]
